export default __webpack_public_path__ + "static/38-bc8226e82cf3dbdcec866ba872d547ea.png";